import ACTION_TYPES from "../ActionTypes";

const { USER } = ACTION_TYPES;

const registerValue = {
  registeredUser: [],
  error: null,
  loading: false,
};

// REGISTER
export const ReducerRegisterUser = (state = registerValue, action) => {
  switch (action.type) {
    case USER.POST_REGISTER_START:
      return { ...state, loading: true };
    case USER.POST_REGISTER_FAILED:
      return { ...state, error: action.payload, loading: false };
    case USER.POST_REGISTER_SUCCESS:
      return { ...state, registeredUser: action.payload, loading: false };
    default:
      return state;
  }
};

// LOGIN
const loginValue = {
  loginedUser: [],
  error: null,
  loading: false,
};

export const ReducerloginUser = (state = loginValue, action) => {
  switch (action.type) {
    case USER.POST_LOGIN_START:
      return { ...state, loading: true };
    case USER.POST_LOGIN_FAILED:
      return { ...state, error: action.payload, loading: false };
    case USER.POST_LOGIN_SUCCESS:
      return { ...state, loginedUser: action.payload, loading: false };
    default:
      return state;
  }
};


// DATA USER
const userValue = {
  dataUser: {},
  error: null,
  loading: false,
};

export const ReducerDataUser = (state = userValue, action) => {
  switch (action.type) {
    case USER.GET_USER_START:
      return { ...state, loading: true };
    case USER.GET_USER_FAILED:
      return { ...state, error: action.payload, loading: false };
    case USER.GET_USER_SUCCES:
      return { ...state, dataUser: action.payload, loading: false };
    default:
      return state;
  }
};

// USE EMAIL VALIDATION
const emailValue = {
  emailValidation: {},
  error: null,
  loading: false,
};

export const ReducerEmailValidation = (state = emailValue, action) => {
  switch (action.type) {
    case USER.GET_EMAIL_VALIDATION_START:
      return { ...state, loading: true };
    case USER.GET_EMAIL_VALIDATION_FAILED:
      return { ...state, error: action.payload, loading: false };
    case USER.GET_EMAIL_VALIDATION_SUCCESS:
      return { ...state, emailValidation: action.payload, loading: false };
    default:
      return state;
  }
};